import React, { Component } from 'react';
import { Image, Col, Row, Container, Button} from 'react-bootstrap';
import Arrow from '../Landing/img/Arrow.svg';
import privacyHTML from '../Landing/pages/components/footer/htmls/privacyContent.js';
import termsHTML from '../Landing/pages/components/footer/htmls/termsContent.js';
import Translate from '../../translate';
import HtmlModal from '../Landing/pages/components/footer/htmlModal';
import './index.css';

let sections, navLi
class TheNewFAQComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
        showPrivacy:false,
        showTerms:false
    }
  }

  highlightOnScroll(){
    let timer = null;
    sections = window.document.querySelectorAll('.section-container');
    navLi = window.document.querySelectorAll('.highlightable');
    window.addEventListener('scroll', ()=>{
      if(timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        let current = '';
        sections.forEach((section, i) => {
          const sectionTop = section.offsetTop;
          const pageYOffset = window.pageYOffset
          const halfHeight = window.innerHeight / 2
          if((pageYOffset + halfHeight) >= sectionTop){
            current = section.getAttribute('id')
          }
        });
        navLi.forEach((li, i) => {
          if(li.classList.contains(current)){
            li.classList.add('active')
          }else li.classList.remove('active')
        });
      }, 50);
    })
  }

  scrollTo(element){
        sections = window.document.querySelectorAll('.section-container');
        var elmntToView = window.document.getElementById(element);
        if(elmntToView) elmntToView.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }

    render() {
        return (
            <div className={'newFAQBG'} id="faq">
            <div style={{height:100}}/>
            <Container className="separator" >
              <div className='FAQ-conatiner'>
                <Row className='faqTitlesRow'>
                  <Col md={{span:9, offset:3}}>
                    <p className='faq-main-title'>{Translate[this.props.lan].faqs.title}</p>
                  </Col>
                  <Col md={{span:9, offset:3}}>
                    <Row className='faqBtnsRow'>
                      <Button className='faqBtn' onClick={()=>this.scrollTo('wirebit')} >{Translate[this.props.lan].faqs.faqBtn1}</Button>
                      <Button className='faqBtn' onClick={()=>this.scrollTo('depositos')} >{Translate[this.props.lan].faqs.faqBtn3}</Button>
                      <Button className='faqBtn' onClick={()=>this.scrollTo('cuenta')} >{Translate[this.props.lan].faqs.faqBtn2}</Button>
                      <Button className='faqBtn' onClick={()=>this.scrollTo('terminos')} >{Translate[this.props.lan].faqs.faqBtn4}</Button>
                    </Row>
                  </Col>
                </Row>
                <Row id='wirebit'>
                  <Col md={3}>
                    <p className='faq-title'>{Translate[this.props.lan].faqs.section1.title}</p>
                  </Col>
                  <Col md={9}>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section1.S1faq1}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section1.S1faq1Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section1.S1faq2}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section1.S1faq2Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section1.S1faq3}</p>
                    <p className='faq-answer'>
                      {Translate[this.props.lan].faqs.section1.S1faq3Ans}
                      <br/>
                      {Translate[this.props.lan].faqs.section1.S1faq3Ans2}
                      <br/>
                      {Translate[this.props.lan].faqs.section1.S1faq3Ans3}
                      <br/>
                      {Translate[this.props.lan].faqs.section1.S1faq3Ans4}
                    </p>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section1.S1faq4}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section1.S1faq4Ans}<br/>{Translate[this.props.lan].faqs.section1.S1faq4Ans2}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section1.S1faq5}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section1.S1faq5Ans}</p>
                  </Col>
                </Row>

                <div className='faq-divider'/>

                <Row id='depositos'>
                  <Col md={3}>
                  <p className='faq-title'>{Translate[this.props.lan].faqs.section2.title}</p>
                  </Col>

                  <Col md={9}>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section2.S2faq1}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section2.S2faq1Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section2.S2faq2}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section2.S2faq2Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section2.S2faq3}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section2.S2faq3Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section2.S2faq4}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section2.S2faq4Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section2.S2faq5}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section2.S2faq5Ans}</p>
                  </Col>
                </Row>

                <div className='faq-divider'/>

                <Row id='cuenta'>
                  <Col md={3}>
                  <p className='faq-title'>{Translate[this.props.lan].faqs.section3.title}</p>
                  </Col>

                  <Col md={9}>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq1}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq1Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq2}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq2Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq3}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq3Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq4}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq4Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq5}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq5Ans}</p>

                    <p className='faq-question'>{Translate[this.props.lan].faqs.section3.S3faq6}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section3.S3faq6Ans}</p>
                  </Col>
                </Row>

                <div className='faq-divider'/>

                <Row id='terminos'>
                  <Col md={3}>
                  <p className='faq-title'>{Translate[this.props.lan].faqs.section4.title}</p>
                  </Col>
                  <Col md={9}>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section4.S4faq1}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section4.S4faq1Ans}</p>
                    <p className='faq-link-terms' onClick={()=>this.setState({showTerms:true})}>{Translate[this.props.lan].faqs.section4.S4faq1Terms} 
                      <Image className="responsive-icon" src={Arrow} />
                    </p>
                    <p className='faq-question'>{Translate[this.props.lan].faqs.section4.S4faq2}</p>
                    <p className='faq-answer'>{Translate[this.props.lan].faqs.section4.S4faq2Ans}</p>
                    <p className='faq-link-terms' onClick={()=>this.setState({showPrivacy:true})}>{Translate[this.props.lan].faqs.section4.S4faq2Terms} 
                      <Image className="responsive-icon" src={Arrow} />
                    </p>
                  </Col>
                </Row>

              </div>
            </Container>
            <HtmlModal
                show={this.state.showPrivacy}
                close={()=>this.setState({showPrivacy:false})}
                html={privacyHTML}
            />
            <HtmlModal
                show={this.state.showTerms}
                close={()=>this.setState({showTerms:false})}
                html={termsHTML}
            />
        </div>
        );
    }
}
export default TheNewFAQComponent
